import jss from "jss";
import preset from "jss-preset-default";
// import { StyleSheet } from "aphrodite-jss";

jss.setup(preset());
// extend: 'button'
const styles = {
  "@global": {
    ".order-detail": {
      "& a": {
        color: "#7fb401",
        fontWeight: 500,
        "&:hover": {
          textDecoration: "underline",
        },
      },
    },
    ".text-small": { fontSize: 14, color: "#666" },
    footer: {
      backgroundColor: "#333",
      "& ul": {
        marginTop: 10,
        "& li": {
          position: "relative",
          "&:last-child": { "& a": { border: [0, "none"] } },
          // "&:before": {
          //   marginTop: -3,
          //   backgroundColor: "#66cc33",
          //   content: '""',
          //   width: 5,
          //   height: 5,
          //   borderRadius: "50%",
          //   position: "absolute",
          //   left: 0,
          //   top: "50%",
          // },

          "& a": {
            transition: "all 200ms ease-out",
            color: "#999",
            padding: [5, 15],
            display: "block",
            borderBottom: [1, "dotted", "#666"],
            "&:hover": { color: "#66cc33" },
          },
        },
      },
    },

    nav: {
      backgroundColor: "#7fb401",
      position: "relative",
      zIndex: 100,
      "& ul": {
        margin: 0,
        padding: 0,
        "& li": {
          display: "inline",
          "& li:last-child a": { border: 0 },
          "& a": {
            display: "inline-block",
            transition: "background-color 1s ease-out",
            borderRight: [1, "solid", "#ccc"],
            color: "#FFF",
            padding: 15,
            "&:hover": {
              backgroundColor: "#91cc08",
              color: "#FFF",
            },
          },
        },
      },
    },
    "@media (max-width: 576px)": {
      ".m-center": { textAlign: ["center", "!important"] },
      ".m-hidden": { display: ["none", "!important"] },
      ".m-flex-jc-center": { justifyContent: ["center", "!important"] },
      nav: {
        margin: "0px !important",
        padding: "0px !important",
        "& ul": {
          width: "100%",
          float: "left",
          "& li": {
            display: "none",
            width: "100%",
            "& a": {
              width: "100%",
              textAlign: "center",
              border: [0, "none", "transparent"],
              borderBottom: [1, "solid", "#ccc"],
            },
          },
          "& li:first-child": {
            textAlign: "left",
            display: "block",
            "& a": {
              border: [0, "none", "transparent"],
            },
          },
        },
      },
    },
  },

  headerTop: {
    textTransform: "capitalize",
    fontSize: "14px",
    color: "#9c9c9c",
    fontWeight: "normal",
    marginLeft: "15px",
    "& span": { color: "#7fb401" },
    "&:hover": { color: "#666" },
  },
  headerTopRightUL: {
    display: "flex",
    fontSize: 15,
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    "& a": {
      paddingLeft: 20,
      "&:hover": { color: "#666" },
    },
    "& span": { color: "#9c9c9c" },
    "& li": {
      position: "relative",
      color: "#fff",
      "&:after": {
        position: "absolute",
        content: '""',
        right: -10,
        top: 1,
        width: 1,
        height: 20,
        borderLeft: [1, "dotted", "#9c9c9c"],
      },
    },
  },
  headerTopSocialUL: {
    display: "flex",
    marginLeft: 20,
    "& li": { paddingLeft: 10 },
    "& .facebook": { fontSize: 20, color: "#3b5998" },
    "& .instagram": { fontSize: 20, color: "#cd486b" },
  },
  header: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 120,
  },
  cartWrapper: {
    marginRight: 20,
    position: "relative",
    display: "flex",
    justifyContent: "flex-end",
    zIndex: 200,
    "& .cart-detail": {
      zIndex: "200 !important",
      textAlign: "center",
      padding: 10,
      backgroundColor: "#252622",
      position: "absolute",
      width: 350,
      minHeight: 100,
      marginLeft: 20,
      top: 82,
      "& .empty-cart": { margin: 20, color: "#FFF" },
      "& .cart-detail-footer": {
        textAlign: "left",
        padding: 10,
        "& span": { fontSize: 16, color: "#fff", paddingTop: 5, float: "left" },
        "& a": {
          margin: [0, 10],
          float: "right",
          padding: [5, 10],
          "&:hover": { backgroundColor: "#fff", color: "#000" },
        },
      },
    },
    "& .cart": {
      cursor: "pointer",
      width: 45,
      height: 45,
      borderRadius: 45 / 2,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
      border: [1, "solid", "#7fb401"],
      "& span": {
        paddingTop: 1,
        fontSize: 13,
        borderRadius: 10,
        width: 20,
        height: 20,
        textAlign: "center",
        backgroundColor: "#7fb401",
        color: "#FFF",
        position: "absolute",
        top: -5,
        right: -5,
      },
    },
    "& .cart-info": {
      fontSize: 14,
      marginLeft: 15,
      color: "#888",
      "& div": {
        "& a": { "&:hover": { textDecoration: "underline", color: "#666" } },
      },
      "& div.price": { color: "#7fb401", fontWeight: "bold" },
    },
  },

  cartWrapperDetail: {
    cursor: "default",
    margin: 0,
    padding: 0,
    listStyle: "none",
    "& li:first-child": { borderTop: [0, "none"], padding: 0 },
    "& li": {
      borderTop: [1, "solid", "#333"],
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-start",
      marginBottom: 10,
      paddingTop: 10,
      "& div": { display: "inline", color: "#FFF" },
      "& .product-thumb": { "& img": { width: 70, height: 70 } },
      "& .product-detail": {
        marginLeft: 8,
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      },
      "& .product-name": {
        fontWeight: "bold",
        "& a": { color: "#fff", "&:hover": { color: "#999" } },
      },
      "& .product-price": { fontSize: 14, color: "#ccc" },
      "& .product-action": {
        alignSelf: "center",
        "& button": {
          outline: "none",
          cursor: "pointer",
          color: "#FFF",
          width: 25,
          height: 25,
          display: "flex",
          fontSize: 14,
          alignItems: "center",
          borderRadius: 25 / 2,
          justifyContent: "center",
          backgroundColor: "rgb(193, 27, 9)",
          border: 0,
        },
      },
    },
  },

  headerSectionTitle: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 20,
    marginBottom: 30,
    textAlign: "center",
  },
  featuredProductTitle: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    textAlign: "center",
    fontFamily: "'Lato', sans-serif",
    color: "#222",
    letterSpacing: 3,
    fontWeight: 900,
    textTransform: "uppercase",
    margin: 0,
    marginTop: 20,
    fontSize: 30,
    "&> span": {
      color: "#88c000",
      position: "relative",
      "&:before": {
        zIndex: -1,
        content: "''",
        position: "absolute",
        width: "100%",
        backgroundColor: "#e5e5e5",
        height: 1,
        left: 0,
        top: "50%",
      },
      "& span": { backgroundColor: "#FFF", paddingLeft: 7, paddingRight: 7 },
    },
  },
  productItem: {
    cursor: "pointer",
    // transition: "all 0.5s",
    "& .product-thumb": {
      transition: "all 0.5s",
      position: "relative",
      overflow: "hidden",
    },

    "& .product-thumb-detail": {
      transition: "all 0.5s",
      display: "none",
      zIndex: 2,
      position: "absolute",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "100%",
      "& > a": {
        cursor: "pointer",
        transition: "all 0.5s",
        height: "100%",
        width: "100%",
        // borderRadius: 20,
        // backgroundColor: "#6c3",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "& span": {
          transition: "all 0.5s",
          height: 40,
          width: 40,
          borderRadius: 20,
          backgroundColor: "#6c3",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          "&:hover": {
            cursor: "pointer",
            backgroundColor: "#ffcc00",
          },
        },
      },
    },

    marginTop: 30,
    padding: 20,
    "& img": { transition: "all 0.5s", width: "100%" },
    "& .product-info": {
      "& .product-price": {
        textAlign: "center",
        "& span.special-price": {
          fontFamily: "'Poppins', sans-serif",
          fontSize: 18,
          color: "#66cc33",
        },
        "& span.old-price": {
          marginRight: 5,
          textDecoration: "line-through",
          fontFamily: "'Poppins', sans-serif",
          color: "#999",
          fontSize: 14,
        },
      },
      "& h3.product-title": {
        color: "#333",
        cursor: "pointer",
        fontFamily: "'Poppins', sans-serif",
        margin: [15, 0, 7],
        fontSize: 17,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      },
    },
    "& .product-extra-link": {
      textAlign: "center",
      "& a": {
        transition: [{ property: "all", duration: "200ms" }],
        width: 160,
        padding: [8, 20],
        color: "#fff",

        display: "inline-block",
        margin: [4, 3, 0, 3],
        height: 40,
        borderRadius: 20,
        border: [1, "solid", "#e5e5e5"],
        textAlign: "center",
        position: "relative",
        backgroundColor: "#66cc33",
        "&:hover": {
          backgroundColor: "#ffcc00",
        },
      },
    },
    "&:hover": {
      "& .product-thumb": {
        backgroundColor: "#000",
        "& img": { opacity: 0.7, transform: "scale(1.1)" },
      },
      "& .product-thumb-detail": {
        display: "flex",
      },
      "&:after": {
        top: -10,
        left: -10,
        bottom: -25,
        right: -10,
        opacity: 1,
      },
    },
    "&:after": {
      zIndex: [-1, "!important"],
      border: [1, "solid", "#e5e5e5"],
      opacity: 0,
      background: "#fff",
      boxShadow: "0 10px 10px 0 rgba(0, 0, 0, 0.15)",
      position: "absolute",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      content: '""',
      transition: "all 0.5s ease-out 0s",

      "-webkit-transition": "all 0.3s ease",
      "-moz-transition": "all 0.3s ease",
      "-ms-transition": "all 0.3s ease",
      "-o-transition": "all 0.3s ease",
    },
  },
  addCart: {
    backgroundColor: ["#ffcc00", "!important"],
    width: [40, "!important"],
    paddingLeft: [0, "!important"],
    paddingRight: [0, "!important"],
    transition: [{ property: "all", duration: "200ms" }],
    // "& span": { display: "none" }
  },
  cartPositionLeft: { left: "3rem" },
  cartPositionRight: { right: "3rem" },
  bottomCartWrapper: {
    visibility: "hidden",
    opacity: 1,
    cursor: "pointer",
    backgroundColor: "#fff",
    position: "fixed",
    bottom: "4rem",
    zIndex: 200,
    transform: "scale(1.5)",
    display: "flex",
    width: 60,
    height: 60,
    borderRadius: 5,
    textAlign: "center",
    transition: [{ property: "all", duration: "200ms" }],
    boxShadow: {
      x: 0,
      y: 0,
      blur: 10,
      spread: 2,
      color: "rgba(0, 0, 0, 0.15)",
    },
    alignItems: "center",
    justifyContent: "center",
    "& > div > span": {
      paddingTop: 2,
      fontSize: 14,
      position: "absolute",
      top: 0,
      right: 0,
      border: "1px solid #ccc",
      width: 25,
      height: 25,
      borderRadius: 25 / 2,
      textAlign: "center",
      marginTop: -5,
      marginRight: -5,
      backgroundColor: "#7fb401",
      color: "#FFF",
    },
    "& .cart-detail": {
      "&.right": { right: "calc(-350px + 60px)" },
      "&.left": { right: "0px" },

      bottom: 70,
      zIndex: "200 !important",
      textAlign: "center",
      padding: 10,
      backgroundColor: "#252622",
      position: "absolute",
      maxWidth: 400,
      minWidth: 350,
      minHeight: 100,
      "& .empty-cart": { margin: 20, color: "#FFF" },
      "& .cart-detail-footer": {
        textAlign: "left",
        padding: 10,
        "& span": { fontSize: 16, color: "#fff", paddingTop: 5, float: "left" },
        "& a": {
          margin: [0, 10],
          float: "right",
          padding: [5, 10],
          "&:hover": { backgroundColor: "#fff", color: "#000" },
        },
      },
    },
  },
  mainFooter: {
    color: "#9c9c9c",
    background: "#2c2c2c",
    padding: [50, 0],
    "& h3": {
      marginBottom: 20,
      fontSize: 24,
      fontFamily: "'Poppins', sans-serif",
      fontWeight: 400,
      color: "#fff",
    },
  },
  bottomFooter: {
    paddingTop: 20,
    paddingBottom: 20,
    color: "#999",
    "& a": {
      color: "#ccc",
      "&:hover": {
        color: "#fff",
      },
    },
  },
  widget: {
    backgroundColor: "#fff",
    border: [1, "solid", "#e5e5e5"],
    borderRadius: 4,

    overflow: "hidden",
    marginTop: 10,
    marginBottom: 10,
    "& .widget-title": {
      color: "#444",
      fontFamily: "'Poppins', sans-serif",
      fontSize: 16,
      fontWeight: 700,
      margin: 0,
      // position: "relative",
      textTransform: "uppercase",

      backgroundColor: "#fafafa",
      padding: 15,
    },
    "& .widget-content": {
      margin: 0,
      borderTop: [1, "solid", "#e5e5e5"],
      padding: 10,
      "& ul li": {
        // padding: [0, 0, 5],
        // marginBottom: 5
      },
      "& ul li a": {
        fontFamily: "'Open Sans', sans-serif",
        position: "relative",
        transition: "all 200ms",
        color: "#666",
        display: "block",
        fontSize: 14,
        borderBottom: [1, "dotted", "#ddd"],
        padding: [8, 0],
        paddingLeft: 15,
        margin: [0, 10],
        "&:before": {
          content: "''",
          width: 8,
          height: 8,
          borderRadius: 4,
          position: "absolute",
          top: 14,
          left: 0,
          border: [1, "solid", "#7fb401"],
          transition: "all 0.3s ease-in-out",
          "-webkit-transition": "all 0.3s ease-in-out",
        },
        "&:hover": {
          color: "#333",
          "&:before": { backgroundColor: "#7fb401" },
        },
      },
      "& ul li:last-child a": {
        border: 0,
      },
    },
  },
  pageTitle: {
    padding: 80,
    background: "right center url(/images/page-title.jpg) fixed",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& h2": {
      fontFamily: '"Poppins", sans-serif',
      textAlign: "center",
      color: "#fff",
      fontSize: 40,
      fontWeight: "bold",
    },
  },
  productWrapper: {
    "& h3": {
      fontSize: 25,
      fontFamily: "'Poppins', sans-serif",
      marginTop: 15,
      marginBottom: 20,
    },
    "& .product-image-preview": {},
    "& .product-images": {
      "& img": {
        cursor: "pointer",
        margin: [5, 5, 0, 0],
        width: 75,
        height: 75,
        "&:hover": { borderColor: "#888" },
      },
    },
    "& .product-stock": {
      fontSize: 14,
      color: "#666",
      "& span": { fontWeight: "bold", color: "#333" },
    },
    "& .product-price": {
      "& span": { fontWeight: "bold", color: "#333" },
      "& .old-price": {
        color: "#999",
        fontSize: 18,
        fontFamily: "'Poppins', sans-serif",
        marginRight: 5,
        textDecoration: "line-through",
      },
      "& .special-price": {
        color: "#66cc33",
        fontSize: 22,
        fontFamily: "'Poppins', sans-serif",
      },
      "& .discount-price": {
        fontSize: 18,
        textDecoration: "line-through",
        color: "#999",
      },
    },
    "& .product-price-discount": {
      "& span": { fontWeight: "bold", color: "#333" },
      "& .old-price": {
        color: "#999",
        fontSize: 18,
        fontFamily: "'Poppins', sans-serif",
        marginRight: 5,
        textDecoration: "line-through",
      },
      "& .special-price": {
        color: "#66cc33",
        fontSize: 22,
        fontFamily: "'Poppins', sans-serif",
      },
    },
    "& .quantity": {
      marginTop: 10,
      display: "flex",
      "& button": {
        backgroundColor: "#fff",
        border: [1, "solid", "#e8e8e8"],
        width: 30,
        height: 30,
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: 15,
        "&:first-child": {
          borderRight: 0,
        },
        "&:last-child": {
          borderLeft: 0,
        },
      },
      "& input": {
        textAlign: "center",

        backgroundColor: "#fff",
        border: [1, "solid", "#e8e8e8"],
        width: 90,
        height: 30,
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: 15,
        fontWeight: "bold",
        color: "#666",
      },
    },
    "& .add-cart": {
      "& a": {
        color: "#fff",
        width: 160,
        margin: [10, 0, 5, 0],
        border: [1, "solid", "#e5e5e5"],
        height: 40,
        padding: [8, 20],
        display: "inline-block",
        position: "relative",
        transition: "all 200ms",
        textAlign: "center",
        borderRadius: 20,
        backgroundColor: "#66cc33",
      },
      "&:hover a": {
        backgroundColor: "#ffcc00",
      },
    },
    "& .product-category": {
      fontSize: 13,
      backgroundColor: "#e8e8e8",
      borderRadius: 15,
      marginTop: 10,
      padding: [20, 20],
      "& span": {
        fontWeight: "bold",
        color: "#333",
      },
      "& a": {
        color: "#666",
        "&:hover": { color: "#444", textDecoration: "underline" },
      },
    },
    "& .social-bar": {
      marginLeft: 5,
      marginTop: 10,
      "& span": {
        display: "block",
        fontWeight: "bold",
        color: "#333",
      },
      "& ul": {
        "& li": {
          display: "inline",
          marginRight: 10,
          padding: 0,
          "& a": {
            opacity: 1,
            transition: "all 500ms",
            fontSize: 25,
            "&:hover": { opacity: 0.6 },
          },
          "& a.facebook": { color: "#3B5998" },
          "& a.twitter": { color: "#1DA1F2" },
          "& a.pinterest": { color: "#BD081C" },
          "& a.google-plus": { color: "#DB4437" },
          "& a.email": { color: "#BD081C" },
        },
      },
    },
  },
  productDetailButton: {
    backgroundColor: "rgb(102, 204, 51)",
    color: "rgb(255, 255, 255)",
    display: "inline-block",
    fontWeight: 700,
    textTransform: "uppercase",
    fontSize: 14,
    borderRadius: 5,
    padding: [10, 20],
  },
  productDetail: {
    marginTop: 10,
    marginBottom: 20,
    padding: 20,
    border: [1, "solid", "#e8e8e8"],
    borderRadius: 5,
    color: "#333",
  },
  onlineShopButtonn11: {
    transition: "all 0.3s",
    transform: " scale(0.9)",
    // marginLeft: 5,
    marginTop: 5,
    display: "inline-flex",
    backgroundColor: "rgb(237, 50, 30)",
    borderRadius: 20,
    justifyContent: "center",
    alignItems: "center",
    // padding: "0 20px 0 0",
    padding: "0 20px 0 45px",
    color: "#fff",
    height: 40,
    fontSize: 15,
    position: "relative",
    "&:hover": {
      backgroundColor: "#f00",
      color: "#FFF",
      padding: "0 50px 0 15px",
      "& img": {
        // right: -5,
        // left: "auto",
        transform: "translateX(135px) rotate(60deg)",
        // transform: "translateX(130px)"
      },
    },
    "& img": {
      transition: "all 0.3s",
      position: "absolute",
      left: -5,
      top: -12,
      height: 55,
      // marginLeft: -15,
      // marginTop: -8,
      // marginRight: 2
    },
  },
  onlineShopButtonhepsiburada: {
    transition: "all 0.3s",
    transform: " scale(0.9)",
    // marginLeft: 5,
    marginTop: 15,
    display: "inline-flex",
    backgroundColor: "#e88a0a",
    borderRadius: 20,
    justifyContent: "center",
    alignItems: "center",
    // padding: "0 20px 0 0",
    padding: "0 20px 0 50px",
    color: "#fff",
    height: 40,
    fontSize: 15,
    position: "relative",
    "&:hover": {
      backgroundColor: "#ffa62e",
      color: "#FFF",
      padding: "0 50px 0 15px",
      "& img": {
        // right: -5,
        // left: "auto",
        transform: "translateX(135px) rotate(30deg)",
        // transform: "translateX(130px)"
      },
    },
    "& img": {
      transition: "all 0.3s",
      transform: "rotate(-20deg)",
      position: "absolute",
      left: -5,
      top: -5,
      height: 50,
      // marginLeft: -15,
      // marginTop: -8,
      // marginRight: 2
    },
  },
  cartDetail: {
    overflow: "hidden",
    border: 0,
    borderRadius: 5,
    margin: [0, -1, 24, 0],
    textAlign: "left",
    width: "100%",
    "& thead": {
      background: "#f5f5f5",
      borderRadius: 7,
      color: "#222222",
      fontFamily: '"Roboto",sans-serif',
      fontSize: 18,
      position: "relative",
      textTransform: "uppercase",
      width: "100%",
      borderBottom: [1, "solid", "#ccc"],
      "& th": {
        color: "#262626",
        fontFamily: '"Roboto",sans-serif',
        fontSize: 16,
        textTransform: "uppercase",
        paddingTop: 10,
        paddingBottom: 10,
      },
    },
    "& .remove": {
      transform: "translateX(-1000px)",
    },
    "& .cart-item ": {
      transition: "all 500ms",
      borderBottom: [1, "solid", "#ccc"],
      "& .product-thumb": {
        paddingTop: 20,
        paddingBottom: 20,
        textAlign: "center",
        "& img": { height: 120 },
      },
      "& .product-name": {
        fontWeight: "bold",
        "& a": { color: "#000", "&:hover": { color: "#444" } },
      },
      "& .product-status": {
        "& a": {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "#FFF",
          width: 25,
          height: 25,
          fontSize: 14,
          borderRadius: 25 / 2,
          backgroundColor: "rgb(237, 50, 30)",
          "&:hover": {
            background: "#f00",
          },
        },
      },
      "& .product-quantity": {
        "& ul": {
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          "& li.quantity": {
            border: [1, "solid", "#ccc"],
            display: "flex",
            flexDirection: "column",
            "& span": { fontSize: 12, textAlign: "center" },
          },
          "& li": {
            display: "inline",
            "&:first-child button": { borderRight: 0 },
            "&:last-child button": { borderLeft: 0 },
            "& button": {
              color: "gray",
              background: "#e2e2e2",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",

              height: 38,
              border: [1, "solid", "#ccc"],
            },
            "& input": {
              margin: 0,
              padding: 0,
              border: 0,
              height: 18,
              width: 40,
              fontSize: 14,
              textAlign: "center",
            },
          },
        },
      },
    },
  },
  orderSummary: {
    "& ul": {
      "& .sperator": {
        borderBottom: [1, "solid", "#ccc"],
        paddingTop: 10,
        marginBottom: 10,
      },
      "& li": {
        "&:last-child": { fontWeight: "bold", fontSize: 16 },
        fontSize: 15,
        "& strong": { fontSize: 13 },
        "& span": { float: "right" },
      },
    },
    "& button": {
      marginRight: -4,
      marginTop: 5,
      cursor: "pointer",
      backgroundColor: "#66cc33",
      color: "#fff",
      padding: [10, 15],
      fontFamily: "'Poppins', sans-serif",
      fontSize: 14,
      border: 0,
      borderRadius: 4,
      transition: "all 0.3 ease",
      "&:hover": { backgroundColor: "#55b127" },
    },
  },
  loginBox: {
    position: "relative",
    background: "url('/images/bg-signin.jpg')",
    padding: [58, 73],
    margin: [50, 0],
    minHeight: 200,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    "-webkit-box-shadow": "0 5px 15px rgba(0,0,0,0.5)",
    "-khtml-box-shadow": "0 5px 15px rgba(0,0,0,0.5)",
    "-moz-box-shadow": "0 5px 15px rgba(0,0,0,0.5)",
    "-ms-box-shadow": "0 5px 15px rgba(0,0,0,0.5)",
    "-o-box-shadow": "0 5px 15px rgba(0,0,0,0.5)",
    "box-shadow": "0 5px 15px rgba(0,0,0,0.5)",
    "& .overlay-content": {
      zIndex: 1,
      backgroundColor: "#ffffff",
      opacity: 0.8,
      position: "absolute",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
    },
    "& .tab-content": {
      position: "relative",
      zIndex: 1,
      padding: [35, 0, 0],
      color: "#696969",
      "& h3": {
        marginBottom: 60,
        color: "#000000",
        fontSize: 24,
      },
      "& .large_form": {
        marginBottom: 15,
        "& input": {
          height: "auto",
          display: "inline-block",

          fontSize: 14,
          width: "100%",
          background: "transparent",
          border: 0,
          borderRadius: 0,
          borderBottom: [2, "solid", "#577725"],
          padding: [0, 0, 6],
          color: "#212121",
          marginBottom: 24,
          outline: "none",
        },

        "& a.forgot-password": {
          color: "#000",
          fontSize: 13,
          transition: "all ease-in-out .3s",
          fontWeight: 300,
          textDecoration: "underline",
          "&:hover": {
            color: "#90c43e",
          },
        },
        "& button": {
          marginTop: 48,
          background: "#88c000",
          border: 0,
          color: "#ffffff",
          cursor: "pointer",
          display: "inline-block",
          "letter-spacing": 2.14,
          fontWeight: 700,
          fontSize: 14,
          fontFamily: "'Lato', sans-serif",
          borderRadius: 3,
          textTransform: "uppercase",
          padding: [15, 35],
          "-webkit-transition": "all ease-in-out 0.3s",
          "-khtml-transition": "all ease-in-out 0.3s",
          "-moz-transition": "all ease-in-out 0.3s",
          "-ms-transition": "all ease-in-out 0.3s",
          "-o-transition": "all ease-in-out 0.3s",
          transition: "all ease-in-out 0.3s",
          "&:hover": {
            backgroundColor: "#333",
            borderColor: "#333",
            color: "#ffffff",
          },
        },
        "& p": {
          marginTop: 20,
          fontSize: 12,
          color: "#666",
          lineHeight: 1.5,
          "& a": {
            transition: "all ease-in-out .3s",
            color: "#444",
            textDecoration: "underline",
            "&:hover": {
              color: "#90c43e",
            },
          },
        },
      },
    },
  },

  accountList: {
    margin: 0,
    padding: 0,
    listStyle: "none",
    "& li": {
      "&:hover": {
        "& a": {
          color: "#777",
        },
      },
      "& a": {
        color: "#484848",
        "&:hover": {
          color: "#777",
          "& img": {
            boxShadow: "0 0px 10px 0 rgba(0, 0, 0, 0.5)",
          },
        },
      },
      fontWeight: "bold",
      width: 160,
      textAlign: "center",
      marginRight: 8,
      display: "inline-block",
      fontFamily: "'Lato', sans-serif",
      fontSize: 15,
      color: "#484848",
      paddingTop: 5,
      textTransform: "uppercase",
      "& img": {
        padding: 20,
        // border: [1, "solid", "#ccc"],
        marginBottom: 10,
        borderRadius: 5,
        boxShadow: "0 0px 10px 0 rgba(0, 0, 0, 0.15)",
      },
    },
  },
  buttonDefaultSM: {
    "&:hover": { color: "#fff", backgroundColor: "#63c333" },
    "&:disabled": { opacity: 0.6 },

    color: "#fff",
    cursor: "pointer",
    border: 0,
    padding: [10, 15],
    fontSize: 14,
    marginTop: 5,
    transition: "all 0.3 ease",
    fontFamily: "'Poppins', sans-serif",
    borderRadius: 4,
    backgroundColor: "#66cc33",
  },
  buttonDefault: {
    marginTop: 48,
    background: "#88c000",
    border: 0,
    color: "#ffffff",
    cursor: "pointer",
    display: "inline-block",
    "letter-spacing": 2.14,
    fontWeight: 700,
    fontSize: 14,
    fontFamily: "'Lato', sans-serif",
    borderRadius: 3,
    textTransform: "uppercase",
    padding: [15, 20],
    "-webkit-transition": "all ease-in-out 0.3s",
    "-khtml-transition": "all ease-in-out 0.3s",
    "-moz-transition": "all ease-in-out 0.3s",
    "-ms-transition": "all ease-in-out 0.3s",
    "-o-transition": "all ease-in-out 0.3s",
    transition: "all ease-in-out 0.3s",
    "&:hover": {
      backgroundColor: "#333",
      borderColor: "#333",
      color: "#ffffff",
    },
  },
  buttonDark: {
    marginRight: 10,
    marginTop: 48,
    background: "#444",
    border: 0,
    color: "#ffffff",
    cursor: "pointer",
    display: "inline-block",
    "letter-spacing": 2.14,
    fontWeight: 700,
    fontSize: 14,
    fontFamily: "'Lato', sans-serif",
    borderRadius: 3,
    textTransform: "uppercase",
    padding: [15, 20],
    "-webkit-transition": "all ease-in-out 0.3s",
    "-khtml-transition": "all ease-in-out 0.3s",
    "-moz-transition": "all ease-in-out 0.3s",
    "-ms-transition": "all ease-in-out 0.3s",
    "-o-transition": "all ease-in-out 0.3s",
    transition: "all ease-in-out 0.3s",
    "&:hover": {
      backgroundColor: "#333",
      borderColor: "#333",
      color: "#ffffff",
    },
  },
  addressesList: {
    flexWrap: "wrap",
    display: "flex",
    margin: [20, 0],
    padding: 0,
    listStyle: "none",
    "& li:first-child": { color: "#06c" },
    "& li": {
      "&.active": {
        boxShadow: "0 0px 10px 5px rgba(0, 0, 0, 0.15)",
        borderColor: "#32be23",
      },
      "&:hover": {
        backgroundColor: "#f9f9f9",
      },
      "& span": {
        color: "#555",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 40,
        height: 40,
        borderRadius: 20,
        border: [1, "solid", "#a2a2a2"],
        marginBottom: 10,
      },
      "& span.name": {
        textTransform: "capitalize",
        display: "initial",
        alignItems: "initial",
        justifyContent: "initial",
        width: "initial",
        height: "initial",
        borderRadius: "initial",
        border: "initial",
        marginBottom: "initial",
        color: "#999",
      },
      margin: 5,
      cursor: "pointer",
      color: "#444",
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      textAlign: "center",
      width: 200,
      height: 200,
      border: [1, "solid", "#dedede"],
    },
  },
  payment: {
    width: "100%",
    "& span": {
      fontSize: 14,
      color: "#666",
    },
  },
  paymentCheckLabel: {
    fontWeight: "bold",
    cursor: "pointer",
    background: "#849BB5",
    fontSize: "120%",
    color: "#FFF",
    padding: 8,
    display: "block",
    marginTop: 5,
    width: "100%",
    borderRadius: 8,
  },
  orderListTable: {
    overflow: "hidden",
    border: 0,
    borderRadius: 5,
    margin: [0, -1, 24, 0],
    textAlign: "left",
    width: "100%",
    "& thead": {
      background: "#f5f5f5",
      color: "#222222",
      fontFamily: '"Roboto",sans-serif',
      fontSize: 18,
      position: "relative",
      textTransform: "uppercase",
      width: "100%",
      borderBottom: [1, "solid", "#ccc"],
      "& th": {
        color: "#262626",
        fontFamily: '"Roboto",sans-serif',
        fontSize: 16,
        textTransform: "uppercase",
        paddingTop: 10,
        paddingLeft: 5,
        paddingBottom: 10,
      },
    },
    "& tr": {
      borderBottom: [1, "solid", "#f1f1f1"],
      "& td": { paddingBottom: 8, paddingTop: 8 },
    },
  },
  footerContact: {
    listStyle: "none",
    margin: 0,
    padding: 0,
    "& li:before": { display: "none" },
    "& li": {
      listStyle: "none",
      padding: 5,
      borderBottom: [1, "dotted", "#666"],
      "& span": { color: "#ccc", marginRight: 5 },
    },
  },
  freeShipping: {
    "& .free-shipping-wrapper": {
      border: "1.2px solid #ccc",
      borderRadius: 5,
      display: "inline-flex",
      flexDirection: "row",
      alignItems: "flex-end",
      padding: "0px 8px 5px",
      margin: 5,
      background: "#e2e2e22b",
      "& span": {
        fontSize: 10,
        margin: 0,
        padding: 0,
        color: "#848484b5",
        fontWeight: "bold",
      },
      "& p": {
        margin: "0px 0px 5px",
        padding: 0,
        fontSize: 18,
        lineHeight: "20px",
        color: "#f28b00",
        marginTop: "-5px",
        fontWeight: "bold",
      },
    },
  },

  "@media (max-width: 576px)": {
    header: { paddingTop: 20, paddingBottom: 20 },
    headerTopRightUL: {
      marginLeft: -20,
      "& li": {
        "&:after": {
          display: "none",
        },
      },
    },
    cartWrapper: {
      justifyContent: "center",
      marginBottom: 15,
    },
  },
  // addCartButton: {
  //   width: "auto",
  //   padding: [8, 20],
  //   color: "#fff",
  //   border: "none",
  //   display: "inline-block",
  //   margin: [4, 3, 0, 3],
  //   height: 40,
  //   borderRadius: 20,
  //   border: [1, "solid", "#e5e5e5"],
  //   textAlign: "center",
  //   position: "relative",
  //   backgroundColor: "#66cc33",
  //   "&:hover": {
  //     backgroundColor: "#ffcc00"
  //   }
  // }
};

const { classes } = jss.createStyleSheet(styles).attach();
export default classes;



// WEBPACK FOOTER //
// ./src/thema/style.js